function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
},
/*#__PURE__*/
React.createElement("path", {
  d: "M8.146 20.501a.49.49 0 01-.428-.51.478.478 0 01.015-.131l.942-7.349c0 .009-.049-.015-.146-.015H4.674a.84.84 0 01-.8-.441.828.828 0 01.153-.891L12.173.694a.49.49 0 01.688-.085.488.488 0 01.19.4.5.5 0 01-.008.11L11.65 8.38a.1.1 0 00.022.08.081.081 0 00.067.029h3.588a.842.842 0 01.822.385.746.746 0 01-.114.809l-7.362 10.5a.49.49 0 01-.461.325.442.442 0 01-.066-.007zm-3.151-8.988H8.53a1.166 1.166 0 01.873.349.978.978 0 01.25.75l-.7 5.452 6.028-8.594h-3.245a1.069 1.069 0 01-.817-.377 1.1 1.1 0 01-.239-.89l1.019-5.3z",
  stroke: "transparent",
  strokeMiterlimit: 10
}),
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 .5h20v20H0z"
}));

var SvgKeyAction = function SvgKeyAction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 21,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgKeyAction, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/KeyAction.0bea1c8a.svg";
export { ForwardRef as ReactComponent };